import { enableProdMode } from '@angular/core';//Angular library

//Import Dependencies
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Render application using AppModule
platformBrowserDynamic().bootstrapModule(AppModule);


// WEBPACK FOOTER //
// ./src/main.ts